import type { TRuleWithTheme } from '@/styles/theme';

export const heading: TRuleWithTheme = () => ({
    paddingTop: '0.5rem',
});
